import { render, staticRenderFns } from "./Plates.vue?vue&type=template&id=320a2c3a&scoped=true"
import script from "./Plates.vue?vue&type=script&lang=js"
export * from "./Plates.vue?vue&type=script&lang=js"
import style0 from "./Plates.vue?vue&type=style&index=0&id=320a2c3a&prod&lang=less"
import style1 from "./Plates.vue?vue&type=style&index=1&id=320a2c3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a2c3a",
  null
  
)

export default component.exports